import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormIndicatorSuccess(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="#05BA8C"
      />
      <path
        d="M16.718 8.042a.833.833 0 0 1 .074 1.176l-6.62 7.5a.833.833 0 0 1-1.279-.034L6.347 13.47a.833.833 0 0 1 1.307-1.035l1.927 2.433 5.961-6.753a.833.833 0 0 1 1.176-.073Z"
        fill="#fff"
      />
    </BaseIcon>
  );
}
